import type { EnvironmentId, Permission, User } from '@/deploy/types';

export function can(user: User | null, permission: Permission): boolean {
  if (!user) return false;
  // Admin bypass : rôle admin = toutes les permissions (évite d'avoir à backfill
  // Mongo à chaque nouvelle permission ajoutée côté backend).
  if (user.role === 'admin') return true;
  return user.permissions.includes(permission);
}

export function canDeployTo(user: User | null, env: EnvironmentId): boolean {
  if (!user) return false;
  switch (env) {
    case 'dev':
      return true; // sandbox dev — tout le monde
    case 'beta':
      return can(user, 'cicd.deploy.beta');
    case 'preprod':
      return can(user, 'cicd.deploy.preprod');
    case 'prod':
      return can(user, 'cicd.deploy.prod');
  }
}
